import { Loader2, SendHorizonal } from "lucide-react";
import { Button } from "@/components/primitives/button";
import ChatAvatar from "@/components/shared/ChatAvatar";
import { ChatEntity } from "@/indexedDB/types";
import { useTranslation } from "react-i18next";

interface Props {
  chat: ChatEntity;
  onSend: () => void;
  isLoading: boolean;
}

export default function ForwardMessageBottomBar({
  chat,
  onSend,
  isLoading,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-3 border-t border-border bg-background px-4 py-3">
      <ChatAvatar
        chatId={chat.id}
        chatName={chat.name}
        attachmentId={chat.avatar?.attachmentId}
        secondMemberId={chat.avatar?.secondMemberId}
        isMuted={false}
      />
      <span className="flex-1 truncate text-sm font-medium">{chat.name}</span>
      <Button
        size="icon"
        onClick={onSend}
        disabled={isLoading}
        className="shrink-0"
        aria-label={t("send")}
      >
        {isLoading ? (
          <Loader2 className="size-4 animate-spin" />
        ) : (
          <SendHorizonal className="size-4" />
        )}
      </Button>
    </div>
  );
}
